import React from 'react';
import { Flex, Link, Text } from '@chakra-ui/react';
import { Avatar, ButtonText } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { IAuthorWithEmail } from '@publishing-engine/domain/models';
import { ISubmissionAuthor } from 'src/contexts/FormContext';
import { Overlay } from 'src/components/Overlay';
import { Layout } from 'src/components/Layout';
import { getOrcidUrl } from '../../../utils/utils';

interface Props {
  onBackClick: () => void;
  author: IAuthorWithEmail | ISubmissionAuthor;
  backButtonText?: string;
}

const AuthorDetailsModal: React.FC<Props> = props => {
  const { author, onBackClick, backButtonText } = props;
  const orcidUrl = getOrcidUrl(author.orcid);

  return (
    <Overlay>
      <Layout width="48rem">
        <Flex gap={8} flexDirection="column" justifyContent="start">
          <ButtonText
            leftIcon={<FontAwesomeIcon icon={faArrowLeft} />}
            maxWidth="fit-content"
            onClick={onBackClick}
          >
            {backButtonText || 'Back to Authors'}
          </ButtonText>

          <Flex gap={8} flexDirection="column">
            {/* Author section */}
            <Flex flexDirection="row" gap={4}>
              <Avatar type="user" shape="round" width={20} height={20} />

              {/* Author info */}
              <Flex flexDirection="column">
                <Flex gap={2}>
                  <Text textStyle="headingGroup">
                    {[author.firstName, author.middleName, author.lastName].filter(Boolean).join(" ")}
                  </Text>
                </Flex>

                <Link
                  variant="primary"
                  href={`mailto:${author.email}`}
                  isExternal
                  textStyle="textBody"
                >
                  {author.email}
                </Link>

                {!!orcidUrl && (
                  <Link
                    variant="primary"
                    href={orcidUrl}
                    isExternal
                    textStyle="textBody"
                  >
                    {orcidUrl}
                  </Link>
                )}
              </Flex>
            </Flex>

            {/* Affiliation */}
            <Flex
              padding={4}
              gap={4}
              bgColor="surfacePrimaryFill"
              flexDirection="column"
            >
              <Text textStyle="headingGroup">Affiliations</Text>
              <Text textStyle="textBody">
                {author.affiliation}
                {author.country && `, ${author.country}`}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Layout>
    </Overlay>
  );
};

export default AuthorDetailsModal;
